import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_URL } from '../lib/api';

const TenantContext = createContext(null);

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) return { tenant: null, loading: true };
  return context;
};

export const TenantProvider = ({ children }) => {
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTenant = async () => {
      try {
        const domain = window.location.hostname;
        const res = await fetch(`${API_URL}/tenants/config?domain=${domain}`);
        if (res.ok) {
          const data = await res.json();
          setTenant(data);
          // Apply tenant colors as CSS variables
          if (data.colores) {
            const root = document.documentElement;
            root.style.setProperty('--tenant-primary', data.colores.primary || '#3b82f6');
            root.style.setProperty('--tenant-secondary', data.colores.secondary || '#1e40af');
            root.style.setProperty('--tenant-accent', data.colores.accent || '#f59e0b');
            root.style.setProperty('--tenant-background', data.colores.background || '#0f172a');
            root.style.setProperty('--tenant-text', data.colores.text || '#ffffff');
          }
          // Set page title
          if (data.nombre) {
            document.title = data.nombre;
          }
        }
      } catch (err) {
        console.error('Failed to load tenant config:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchTenant();
  }, []);

  return (
    <TenantContext.Provider value={{ tenant, loading, setTenant }}>
      {children}
    </TenantContext.Provider>
  );
};
